module.exports = __webpack_public_path__ + "static/media/DSC_0069.9c7a00b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0069.jpg
// module id = 627
// module chunks = 0